import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { articleDateContent$key } from "~/queries/__generated__/articleDateContent.graphql";

import { DefaultArticleDate } from "./default-article-date";
import { PlusArticleDate } from "./plus-article-date";

export type Props = {
  reference: articleDateContent$key;
  variant?: "plus" | "default";
};

export const ArticleDate: FunctionComponent<Props> = ({
  reference: reference_,
  variant,
  ...attribs
}) => {
  const content = useFragment(
    graphql`
      fragment articleDateContent on Content {
        ...plusArticleDateContent
        ...defaultArticleDateContent
      }
    `,
    reference_,
  );

  if (!content) return null;

  switch (variant) {
    case "plus":
      return <PlusArticleDate reference={content} />;
    default:
      return <DefaultArticleDate reference={content} {...attribs} />;
  }
};

ArticleDate.displayName = "ArticleDate";
